// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__aeSCA","icon":"Skill_icon__l9v0c","titleAndDescription":"Skill_titleAndDescription__QROR-"};